export default class DocumentIntelligenceProvidersSettings {
    constructor(dto) {
        this.contentTypeID = 0;
        this.documentIntelligenceProviderID = 0;
        this.prebuiltModelID = '';
        this.fieldProviders = [];
        this.lLMModel = '';
        this.fuzzyThreshold = 0;

        if (dto) {
            this.contentTypeID = dto.ContentTypeID;
            this.documentIntelligenceProviderID = dto.DocumentIntelligenceProviderID;
            this.prebuiltModelID = dto.PrebuiltModelID;
            this.fieldProviders = dto.FieldProviders;
            this.lLMModel = dto.LLMModel;
            this.fuzzyThreshold = dto.FuzzyThreshold;
        }
    }

    toDto () {
        return {
            ContentTypeID: this.contentTypeID,
            DocumentIntelligenceProviderID: this.documentIntelligenceProviderID,
            PrebuiltModelID: this.prebuiltModelID,
            FieldProviders: this.fieldProviders,
            LLMModel: this.lLMModel,
            FuzzyThreshold: this.fuzzyThreshold
        };
    }
}
